const formatGraphQLError = error => {
  if (!error) {
    return undefined;
  }
  const { graphQLErrors, message } = error;
  if (!(graphQLErrors && graphQLErrors.length)) {
    return error;
  }
  return {
    ...error,
    message: message.replace(/GraphQL error: /, ''),
  };
};

const round = (value, decimals = 2) =>
  Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);

export { formatGraphQLError, round };
